class NoReturn extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector("#no_return");
    this.property = this.querySelector("#property");

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleCheckboxChange() {
    if (this.checkbox.checked) {
      this.property.value = "Akzeptiert";
      this.addToCart.disabled = false; // Enable button when checked
    } else {
      this.property.value = "Nicht akzeptiert";
      this.addToCart.disabled = true; // Disable button when unchecked
    }
  }
  connectedCallback() {
    this.checkbox.addEventListener("change", this.handleCheckboxChange);
    this.addToCart = document.querySelector("#AddToCart");
    this.addToCart.disabled = true; // Disable button initially
  }
}

customElements.define("no-return", NoReturn);
